import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-symptom-icon',
    templateUrl: './symptom-icon.component.html',
    styleUrls: ['./symptom-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SymptomIconComponent implements OnInit {
  @Input() symptomId: any;
  constructor() {}

  ngOnInit(): void {}
}
